//  actions
import TYPES from './types'

//  initialState
import initialState from './initialState'

// Model
import model from './model'

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SHIPMENT_LIST.FETCH.REQUEST:
      return model.customLoading(state, action.table)
    case TYPES.SHIPMENT_LIST.FETCH.SUCCEEDED:
      return model.saveData(state, action.payload, action.table)
    case TYPES.SHIPMENT_LIST.FETCH.FAILED:
      return model.customError(state, action.payload)
    case TYPES.SHIPMENT_LIST.UPDATE.SELECTED_RATE:
      return model.updateLtlSelectedRate(state, action.refId, action.newSelectedRate)
    case TYPES.SHIPMENT_LIST.UPDATE.STATUS:
      return model.updateStatus(state, action.payload)
    case TYPES.SHIPMENT_LIST.CLEAN.ERRORS:
      return model.clean(state)
    case TYPES.SHIPMENT_LIST.CLEAN.STATE:
      return model.clean(initialState)
    default:
      return state
  }
}
